import store from "@/store";

export function isUserLevel() {
  const systemSettings = store.getters.apiSystemSettings;
  if (systemSettings?.enableUserLevels != "1") {
    return true;
  }
  const profile = store.getters["profile/profile"];
  const settingsLevel = systemSettings?.userLimitStatuses;
  const userLevel = profile?.level;
  const levelsOrder = settingsLevel ? Object.values(settingsLevel) : "";
  const userIndex = levelsOrder.indexOf(userLevel);
  const limitIndex = levelsOrder.indexOf(settingsLevel);
  const result = userIndex >= limitIndex;

  return result;
}